/**
 * @generated SignedSource<<d7e12696d948836effbfd1e33431bf51>>
 * @relayHash 5afb699a706480ed40b8e21f7e3b2be4
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID ece22b9005eec1ca80fb5eb1d513ffda47e38ad08767589730d23363074f219b

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { JourneysPageQuery } from './JourneysPageQuery.graphql';

const node: PreloadableConcreteRequest<JourneysPageQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "ece22b9005eec1ca80fb5eb1d513ffda47e38ad08767589730d23363074f219b",
    "metadata": {},
    "name": "JourneysPageQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
